import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-col max-w-md mx-auto space-y-4 mt-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-5xl font-bold mt-12 mb-8 max-w-xl mx-auto" }, " Guess the lucky number 🍀🎲 ", -1)
const _hoisted_3 = {
  key: 0,
  class: "text-xl"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Enter a number between 1 and 100. If you get the lucky number, you'll win a prize! Current prize is ")
const _hoisted_5 = { class: "font-bold text-indigo-600" }
const _hoisted_6 = {
  key: 1,
  class: "my-8 text-red-500 font-medium"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl" }, " You'll have to pay 0.0001ETH to participate each time. Prize will accumulate until there is a winner. ", -1)
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-red-600" }, " Number must be between 1 and 100 (both included) ", -1)
const _hoisted_10 = { key: 3 }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.walletStore.walletData != null)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.currentPrize) + "ETH", 1)
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_6, " You have to connect your wallet first! ")),
    _hoisted_7,
    _withDirectives(_createElementVNode("input", {
      disabled: _ctx.walletStore.walletData == null,
      class: _normalizeClass(["border ring-none text-indigo-600 font-medium rounded p-2", 
        _ctx.walletStore.walletData == null
          ? 'border-gray-200 text-gray-400'
          : 'border-indigo-500 text-indigo-600 hover:shadow-lg shadow-sm'
      ]),
      type: "number",
      min: "0",
      max: "100",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.number) = $event))
    }, null, 10, _hoisted_8), [
      [_vModelText, _ctx.number]
    ]),
    _hoisted_9,
    (_ctx.showAlert)
      ? (_openBlock(), _createElementBlock("p", {
          key: 2,
          class: _normalizeClass(["text-3xl font-bold", _ctx.isWinner ? `text-green-400` : `text-red-600`])
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.isWinner ? `You've won 🎉!!!` : 'Ohh! Try again '), 1)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.latestNumbers.length > 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Psst! the last numbers played are: " + _toDisplayString(_ctx.latestNumbers.slice(-5)) + " so don't try any of those 😉 ", 1))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.playLottery && _ctx.playLottery(...args))),
      disabled: _ctx.walletStore.walletData == null || _ctx.trxInProgress,
      class: _normalizeClass(["px-4 py-2 mt-8 border font-medium rounded", 
        _ctx.walletStore.walletData == null
          ? 'border-gray-200 text-gray-400'
          : 'border-indigo-500 text-indigo-600 hover:shadow-lg shadow-sm'
      ])
    }, _toDisplayString(_ctx.trxInProgress ? `Sending...` : `Guess number 🎲`), 11, _hoisted_11)
  ]))
}